import { Stack, styled } from 'shell/components';

const PanelSlides = {
    LEFT: 'left',
    RIGHT: 'right',
};

const PanelTransforms = {
    [PanelSlides.LEFT]: 'translateX(-100%)',
    [PanelSlides.RIGHT]: 'translateX(100%)',
};

const PanelTransition = 'transform 300ms ease';

const getPanelConfigs = ({ leftPanel, rightPanel, showRightPanel }) => {
    return [
        {
            content: leftPanel,
            isActive: !showRightPanel,
            key: PanelSlides.LEFT,
            side: PanelSlides.LEFT,
        },
        {
            content: rightPanel,
            isActive: showRightPanel,
            key: PanelSlides.RIGHT,
            side: PanelSlides.RIGHT,
        },
    ];
};

const SlidingPanels = ({ disableAnimation = false, leftPanel, rightPanel, showRightPanel }) => {
    const panelConfigs = getPanelConfigs({ leftPanel, rightPanel, showRightPanel });

    return (
        <PanelsViewport>
            {panelConfigs.map(({ content, isActive, key, side }) => {
                return (
                    <PanelSlide disableAnimation={disableAnimation} isActive={isActive} key={key} side={side}>
                        {content}
                    </PanelSlide>
                );
            })}
        </PanelsViewport>
    );
};

const PanelsViewport = styled(Stack)(() => {
    return {
        position: 'relative',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
    };
});

const PanelSlide = styled(Stack, {
    shouldForwardProp: (prop) => !['disableAnimation', 'isActive', 'side'].includes(prop),
})(({ disableAnimation, isActive, side }) => {
    return {
        position: 'absolute',
        inset: 0,
        minHeight: 0,
        overflow: 'auto',
        transform: isActive ? 'translateX(0)' : PanelTransforms[side],
        transition: disableAnimation ? 'none' : PanelTransition,
        willChange: 'transform',
    };
});

export default SlidingPanels;
